// Investiture
import React from 'react';
import { Kannadacca2class2026 } from '../views';


const InvestiturePage = () => {
  return <Kannadacca2class2026/>;
};

export default InvestiturePage;
